<template>
  <div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
      style="margin-top: 25px"
    >
      <h2>{{ action == "create" ? "Create" : "Edit" }} Machine</h2>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <v-divider></v-divider>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <!-- Machine details -->
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
    >
      <v-card outlined>
        <v-card-title>Machine Details</v-card-title>
        <v-card-subtitle>Please fill in all of the details</v-card-subtitle>
        <div style="padding: 10px">
          <v-form ref="machine_info_form">
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowAutocompleteField
                :is_required="false"
                title="Company Name"
                :items="company_name_options"
                v-model="selected_company_name"
                @input="check_company_name"
                placeholder="Leave Empty if is NuVending Machine"
                :readonly="current_user_company_doc_id != ''"
              ></RowAutocompleteField>
            </div>
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowTextField
                :is_required="true"
                title="Machine ID"
                v-model="machine_id"
                :error_message="machine_id_error_message"
                placeholder="e.g NUMMAPB10621-0180"
                :read_only="current_user_company_doc_id != ''"
                :rules="[() => !!machine_id || 'Machine ID is required']"
                @input="clear_error_message('machine_id')"
              ></RowTextField>
            </div>
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowTextField
                :is_required="true"
                title="Machine Name"
                v-model="machine_name"
                placeholder="e.g Machine 1"
                :rules="[() => !!machine_name || 'Machine name is required']"
              ></RowTextField>
            </div>
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowTextField
                :is_required="false"
                title="Machine Store Code"
                v-model="machine_store_code"
                placeholder="e.g 300-A0001"
              ></RowTextField>
            </div>
            <div
              style="margin-top: 10px; margin-bottom: 10px"
              v-if="is_sm_vm_enable"
            >
              <RowTextField
                :is_required="true"
                title="SM VM Token"
                v-model="sm_vm_token"
                placeholder="e.g VM1234"
                :rules="[() => !!sm_vm_token || 'SM Token name is required']"
              ></RowTextField>
            </div>
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowTextField
                :is_required="true"
                title="Machine Location"
                v-model="location_name"
                placeholder="e.g Nu Vending HQ"
                :rules="[() => !!location_name || 'Location name is required']"
              ></RowTextField>
            </div>
            <div v-if="current_user_company_doc_id == ''">
              <div
                style="margin-top: 10px; margin-bottom: 10px"
                v-if="machine_type == 'Nubox' || machine_type == 'Nubox_v2'"
              >
                <RowComboBox
                  :is_required="true"
                  title="Payment Options"
                  v-model="selected_payment_options"
                  :items="payment_options"
                  :multiple="true"
                  @input="check_payment_options"
                  :rules="[
                    () =>
                      selected_payment_options.length > 0 ||
                      'At least one payment option is needed',
                  ]"
                ></RowComboBox>
              </div>
              <div
                style="margin-top: 10px; margin-bottom: 10px"
                v-if="
                  machine_type == 'Nubox_v2' &&
                  selected_payment_options.includes('Credit Card')
                "
              >
                <RowTextField
                  :is_required="true"
                  title="Gkash Username"
                  v-model="gkash_username"
                  :rules="[
                    () => !!gkash_username || 'Gkash username is required',
                  ]"
                ></RowTextField>
              </div>
              <div
                style="margin-top: 10px; margin-bottom: 10px"
                v-if="
                  machine_type == 'Nubox_v2' &&
                  selected_payment_options.includes('Credit Card')
                "
              >
                <RowTextField
                  :is_required="true"
                  title="Gkash Password"
                  v-model="gkash_password"
                  :rules="[
                    () => !!gkash_password || 'Gkash password is required',
                  ]"
                ></RowTextField>
              </div>
            </div>
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowAutocompleteField
                :is_required="false"
                title="Machine Template"
                v-model="selected_template_name"
                :items="template_list"
                @input="template_selected"
              ></RowAutocompleteField>
            </div>
            <div v-if="current_user_company_doc_id == ''">
              <div style="margin-top: 10px; margin-bottom: 10px">
                <RowAutocompleteField
                  :is_required="true"
                  title="Machine Type"
                  v-model="machine_type"
                  :items="['China', 'Nubox_v2']"
                  @input="slot_changed"
                  :rules="[() => !!machine_type || 'Machine type is required']"
                ></RowAutocompleteField>
              </div>
              <div
                v-if="
                  action == 'edit' &&
                  (machine_type == 'Nubox' || machine_type == 'Nubox_v2')
                "
                style="margin-top: 10px; margin-bottom: 10px"
              >
                <RowTextField
                  :is_required="true"
                  title="API Key"
                  v-model="api_key"
                  :read_only="true"
                ></RowTextField>
              </div>
              <div
                v-if="machine_type == 'Nubox_v2'"
                style="margin-top: 10px; margin-bottom: 10px"
              >
                <RowTextField
                  :is_required="false"
                  title="Machine Password"
                  v-model="machine_password"
                ></RowTextField>
              </div>
              <div
                v-if="machine_type == 'Nubox_v2'"
                style="margin-top: 10px; margin-bottom: 10px"
              >
                <RowAutocompleteField
                  :is_required="true"
                  title="Sub Machine Enable"
                  v-model="is_sub_exist"
                  :items="['True', 'False']"
                  @input="sub_slot_enable"
                  :rules="[
                    () => !!is_sub_exist || 'Sub Machine Enable is required',
                  ]"
                ></RowAutocompleteField>
              </div>
              <div
                v-if="machine_type == 'Nubox_v2'"
                style="margin-top: 10px; margin-bottom: 10px"
              >
                <RowAutocompleteField
                  :is_required="true"
                  title="Multiple Purchase Enable"
                  v-model="multiple_purchase"
                  :items="['True', 'False']"
                  :rules="[
                    () =>
                      !!multiple_purchase ||
                      'Multiple Purchase Enable is required',
                  ]"
                ></RowAutocompleteField>
              </div>
              <div
                v-if="machine_type == 'Nubox_v2'"
                style="margin-top: 10px; margin-bottom: 10px"
              >
                <RowAutocompleteField
                  :is_required="true"
                  title="Need Refund?"
                  v-model="need_refund"
                  :items="['True', 'False']"
                  :rules="[() => !!need_refund || 'Need refund is required']"
                ></RowAutocompleteField>
              </div>
              <div
                v-if="machine_type == 'Nubox_v2'"
                style="margin-top: 10px; margin-bottom: 10px"
              >
                <RowTextArea
                  :is_required="true"
                  title="Refund Text"
                  v-model="refund_text"
                  :rules="[() => !!refund_text || 'Refund text is required']"
                ></RowTextArea>
              </div>
              <div
                v-if="machine_type == 'Nubox_v2'"
                style="margin-top: 10px; margin-bottom: 10px"
              >
                <RowTextArea
                  :is_required="true"
                  title="Non Refund Text"
                  v-model="non_refund_text"
                  :rules="[
                    () => !!non_refund_text || 'Non refund text is required',
                  ]"
                ></RowTextArea>
              </div>
            </div>
            <div
              style="margin-top: 10px; margin-bottom: 10px"
              v-for="(item, index) in machine_temp_field"
              :key="index + 50"
            >
              <RowTextField
                :is_required="true"
                :title="`Machine ${index + 1} Threshold Temperature`"
                v-model="machine_temp_field[index]"
                @keypress="only_for_number"
                :rules="[
                  () =>
                    !!machine_temp_field[index] || 'Temperature is required',
                  () => !isNaN(machine_temp_field[index]) || 'Invalid number',
                  () =>
                    (Number(machine_temp_field[index]) > 0 &&
                      Number(machine_temp_field[index]) <= 100) ||
                    'Must be within the range of 1 - 100',
                ]"
              ></RowTextField>
            </div>
            <div
              style="margin-top: 10px; margin-bottom: 10px"
              v-if="machine_type == 'Nubox_v2'"
            >
              <RowMoreTextField
                :is_required="true"
                :value="email_receiver_list"
                placeholder="Email"
                :multiple="true"
                @update_start_time_value="update_start_time_value($event)"
                @remove_date_time="remove_date_time($event)"
                @add_date_time="add_date_time($event)"
              ></RowMoreTextField>
            </div>
            <div v-if="current_user_company_doc_id == ''">
              <div
                style="margin-top: 10px; margin-bottom: 10px"
                v-for="(item, index) in tray_and_slot"
                :key="index"
              >
                <RowTextField
                  :is_required="true"
                  :title="`Tray ${index + 1} and # Slot`"
                  v-model="item.value"
                  @input="slot_changed"
                  @keypress="only_for_number"
                  :rules="[
                    () => !!item.value || 'Number of slot is required',
                    () => !isNaN(item.value) || 'Invalid number',
                    () =>
                      (Number(item.value) >= 0 && Number(item.value) <= 10) ||
                      'Must be within the range of 0 - 10',
                  ]"
                ></RowTextField>
              </div>
              <div
                style="margin-top: 10px; margin-bottom: 10px"
                v-for="(item, index) in sub_tray_and_slot"
                :key="index + 9999"
              >
                <RowTextField
                  :is_required="true"
                  :title="`Tray ${index + 11} and # Slot`"
                  v-model="item.value"
                  @input="slot_changed"
                  @keypress="only_for_number"
                  :rules="[
                    () => !!item.value || 'Number of slot is required',
                    () => !isNaN(item.value) || 'Invalid number',
                    () =>
                      (Number(item.value) >= 0 && Number(item.value) <= 10) ||
                      'Must be within the range of 0 - 10',
                  ]"
                ></RowTextField>
              </div>
            </div>
          </v-form>
        </div>
      </v-card>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <!-- Ewallet info -->
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
      v-if="current_user_company_doc_id == ''"
    >
      <v-card outlined>
        <v-card-title>E-wallet Info</v-card-title>
        <v-card-subtitle>Please fill in all of the details</v-card-subtitle>
        <div style="padding: 10px">
          <v-form ref="ewallet_form">
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowTextField
                :is_required="true"
                title="Merchant ID"
                v-model="merchant_id"
                :rules="[() => !!merchant_id || 'Merchant ID is required']"
              ></RowTextField>
            </div>
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowTextField
                :is_required="true"
                title="Store ID"
                v-model="store_id"
                :rules="[() => !!store_id || 'Store ID is required']"
              ></RowTextField>
            </div>
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowTextField
                :is_required="true"
                title="App Code"
                v-model="app_code"
                :rules="[() => !!app_code || 'App Code is required']"
              ></RowTextField>
            </div>
            <div style="margin-top: 10px; margin-bottom: 30px">
              <RowTextField
                :is_required="true"
                title="Secret Key"
                v-model="secret_key"
                :rules="[() => !!secret_key || 'Secret Key is required']"
              ></RowTextField>
            </div>
          </v-form>
        </div>
      </v-card>
      <div style="margin-top: 25px; margin-bottom: 25px"></div>
      <v-card outlined v-if="is_ipay88_vm_enable">
        <v-card-title>iPay88 Info</v-card-title>
        <v-card-subtitle>Please fill in all of the details</v-card-subtitle>
        <div style="padding: 10px">
          <v-form ref="ipay88_form">
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowTextField
                :is_required="true"
                title="Merchant Code"
                v-model="ipay88_merchant_code"
                :rules="[
                  () => !!ipay88_merchant_code || 'Merchant Code is required',
                ]"
              ></RowTextField>
            </div>
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowTextField
                :is_required="true"
                title="Merchant Key"
                v-model="ipay88_merchant_key"
                :rules="[
                  () => !!ipay88_merchant_key || 'Merchant key is required',
                ]"
              ></RowTextField>
            </div>
          </v-form>
        </div>
      </v-card>
      <div style="margin-top: 25px; margin-bottom: 25px"></div>
      <!-- Custom color info -->
      <div v-if="this.machine_type == 'Nubox_v2'">
        <v-card outlined>
          <v-card-title>Custom Colour Info</v-card-title>
          <v-card-subtitle>Please fill in all of the details</v-card-subtitle>
          <div style="padding: 10px">
            <div>
              <RowColorPicker
                :is_required="true"
                title="Primary Text Colour"
                :v_model="primary_color"
                hide-canvas
                hide-mode-switch
                mode="hexa"
                swatches-max-height="100"
                :rules="[() => !!primary_color || 'Colour is required']"
                @update_value="update_primary_colour"
              ></RowColorPicker>
            </div>
            <div>
              <RowColorPicker
                :is_required="true"
                title="Redeem Button Colour"
                :v_model="redeem_color"
                hide-canvas
                hide-mode-switch
                mode="hexa"
                swatches-max-height="100"
                :rules="[() => !!redeem_color || 'Colour is required']"
                @update_value="update_redeem_color"
              ></RowColorPicker>
            </div>
            <div>
              <RowColorPicker
                :is_required="true"
                title="Add To Cart Button Colour"
                :v_model="add_to_cart_color"
                hide-canvas
                hide-mode-switch
                mode="hexa"
                swatches-max-height="100"
                :rules="[() => !!add_to_cart_color || 'Colour is required']"
                @update_value="update_add_to_cart_color"
              ></RowColorPicker>
            </div>
            <div>
              <RowColorPicker
                :is_required="true"
                title="Shopping Cart Button Colour"
                :v_model="shopping_cart_color"
                hide-canvas
                hide-mode-switch
                mode="hexa"
                swatches-max-height="100"
                :rules="[() => !!shopping_cart_color || 'Colour is required']"
                @update_value="update_shopping_cart_color"
              ></RowColorPicker>
            </div>
            <div>
              <RowColorPicker
                :is_required="true"
                title="Credit Button Colour"
                :v_model="credit_color"
                hide-canvas
                hide-mode-switch
                mode="hexa"
                swatches-max-height="100"
                :rules="[() => !!credit_color || 'Colour is required']"
                @update_value="update_credit_color"
              ></RowColorPicker>
            </div>
          </div>
        </v-card>
      </div>
      <div style="margin-top: 25px; margin-bottom: 25px"></div>
      <!-- Notification details -->
      <div v-if="this.machine_type == 'Nubox_v2'">
        <v-card outlined>
          <v-card-title>Notification Details</v-card-title>
          <v-card-subtitle
            >Please fill in all of the details if applicable</v-card-subtitle
          >
          <div style="padding: 10px">
            <v-form ref="notification_form">
              <div style="margin-top: 10px; margin-bottom: 10px">
                <RowTextField
                  :is_required="false"
                  title="Whatsapp API Token"
                  v-model="whatsapp_api_token"
                  type="password"
                ></RowTextField>
              </div>
              <div style="margin-top: 10px; margin-bottom: 10px">
                <RowTextField
                  :is_required="false"
                  title="Whatsapp Phone Number"
                  v-model="whatsapp_phone_numbers"
                  hint="E.g. 60162341234, add multiple phones by ';' in between"
                  @keypress="only_for_number_semicolon"
                  :persistent_hint="true"
                  :rules="
                    whatsapp_phone_numbers != '' &&
                    whatsapp_phone_numbers != null
                      ? [
                          () =>
                            whatsapp_number_validation(
                              whatsapp_phone_numbers
                            ) || 'This field only accept 0-9 and ;',
                        ]
                      : []
                  "
                ></RowTextField>
              </div>
            </v-form>
          </div>
        </v-card>
      </div>
    </div>

    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <!-- Slot Details -->
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
    >
      <v-card outlined>
        <v-card-title>Slot Details</v-card-title>
        <v-card-subtitle
          >The slot information will be updated according to the row and slot
          setup above.</v-card-subtitle
        >
        <v-divider></v-divider>
        <v-form ref="machine_slot_form">
          <MachineSlotTable
            :headers="machine_type == 'Nubox_v2' ? headers_v2 : headers"
            :slot_list="slot_list"
            :table_loading="table_loading"
            :is_validated="is_validated"
            :machine_type="
              current_user_company_doc_id == '' ? machine_type : ''
            "
            :componentKey="key_value"
            @product_image_clicked="product_image_clicked"
            @product_description_image_clicked="
              product_description_image_clicked
            "
            @image_uploading="image_uploading"
            @image_selected_success="image_selected_success"
            @image_selected_error="image_selected_error"
            @image_description_uploading="image_description_uploading"
            @image_description_selected_success="
              image_description_selected_success
            "
            @image_description_selected_error="image_description_selected_error"
          ></MachineSlotTable>
        </v-form>
      </v-card>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
    >
      <v-card outlined>
        <v-card-title>Advertisement Video</v-card-title>
        <v-card-subtitle>Please upload advertisement video.</v-card-subtitle>
        <div class="pa-3">
          <v-row align-content="stretch">
            <v-col>
              <div @click="upload_sleep_ads_video">
                <input
                  @change="sleep_ads_video_selected"
                  ref="sleep_ads_video_upload"
                  type="file"
                  accept="video/mp4"
                  hidden
                />
                <div
                  class="ma-3"
                  style="height: 250px; border: 2px dashed #028dd7"
                >
                  <p
                    v-if="sleep_ads_video == ''"
                    style="
                      padding-top: 120px;
                      text-align: center;
                      color: #028dd7;
                      font-size: 14px;
                    "
                  >
                    + Select Sleep Mode Ads
                  </p>
                  <div
                    v-else-if="sleep_ads_video == 'Loading'"
                    style="padding-top: 110px; text-align: center"
                  >
                    <v-progress-circular
                      :size="30"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                  <div v-else style="text-align: center">
                    <video height="250" controls="controls" preload="metadata">
                      <source :src="sleep_ads_video" type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col>
              <div @click="upload_top_banner_ads_video">
                <input
                  @change="top_banner_ads_video_selected"
                  ref="top_banner_ads_video_upload"
                  type="file"
                  accept="video/mp4"
                  hidden
                />
                <div
                  class="ma-3"
                  style="height: 250px; border: 2px dashed #028dd7"
                >
                  <p
                    v-if="top_banner_ads_video == ''"
                    style="
                      padding-top: 120px;
                      text-align: center;
                      color: #028dd7;
                      font-size: 14px;
                    "
                  >
                    + Select Top Banner Ads
                  </p>
                  <div
                    v-else-if="top_banner_ads_video == 'Loading'"
                    style="padding-top: 110px; text-align: center"
                  >
                    <v-progress-circular
                      :size="30"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                  <div v-else style="text-align: center">
                    <video height="250" controls="controls" preload="metadata">
                      <source :src="top_banner_ads_video" type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
        <div
          class="ma-3"
          v-if="
            sleep_ads_error_message != '' || top_banner_ads_error_message != ''
          "
        >
          <p
            v-if="sleep_ads_error_message != ''"
            style="color: red; margin-bottom: 0"
          >
            {{ sleep_ads_error_message }}
          </p>
          <p
            v-if="top_banner_ads_error_message != ''"
            style="color: red; margin-bottom: 0"
          >
            {{ top_banner_ads_error_message }}
          </p>
        </div>
        <div class="ma-3">
          <p style="font-size: 12px; color: grey; margin-bottom: 0">
            Recommended sleep mode video dimension: 1080PX x 1920PX, MP4 Format,
            Less than 30 MB
          </p>
          <p style="font-size: 12px; color: grey; margin-bottom: 0">
            Recommended top banner video dimension: 640PX x 352PX, MP4 Format,
            Less than 30 MB
          </p>
        </div>
      </v-card>
    </div>
    <div style="height: 150px"></div>
    <div style="position: fixed; left: 0; right: 0; width: auto; bottom: 0">
      <v-card
        min-height="100"
        style="padding-top: 10px"
        flat
        outlined
        :style="{
          paddingLeft: generalSpacingLeftRight + '%',
          paddingRight: generalSpacingLeftRight + '%',
        }"
      >
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="ma-3">
            <v-btn
              style="text-transform: capitalize"
              outlined
              @click="$router.push({ path: '/machines' })"
              :disabled="is_submitting"
              >Cancel</v-btn
            >
          </div>
          <div class="ma-3">
            <v-btn
              depressed
              style="text-transform: capitalize"
              class="white--text"
              color="primary"
              :disabled="is_submitting"
              :loading="is_submitting"
              @click="update_machine"
              >Save</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </div>

    <!-- Add this dialog component in the template section -->
    <v-dialog v-model="showZeroPriceDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">
          Zero Prices Detected
        </v-card-title>

        <v-card-text>
          The following slots have price 0:
          <v-list dense>
            <v-list-item v-for="(slot, index) in zeroPriceSlots" :key="index">
              <v-list-item-content>
                <v-list-item-title>{{ slot }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="handleZeroPriceCancel">
            Cancel
          </v-btn>
          <v-btn color="primary" text @click="handleZeroPriceConfirm">
            Proceed
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RowTextField from "../components/RowTextField.vue";
import RowMoreTextField from "../components/RowMoreTextField.vue";
import RowAutocompleteField from "../components/RowAutocompleteField.vue";
import MachineSlotTable from "../components/MachineSlotTable.vue";
import RowComboBox from "../components/RowComboBox.vue";
import RowColorPicker from "../components/RowColorPicker.vue";
import RowTextArea from "../components/RowTextArea.vue";

export default {
  components: {
    RowTextField,
    RowAutocompleteField,
    MachineSlotTable,
    RowComboBox,
    RowMoreTextField,
    RowColorPicker,
    RowTextArea,
  },
  data: function () {
    return {
      action: this.$route.params.id == "create" ? "create" : "edit",
      machine_doc_id: "",
      machine_id: "",
      machine_id_error_message: "",
      original_machine_id: "",
      machine_name: "",
      location_name: "",
      machine_type: "Nubox_v2",
      api_key: "",
      is_sub_exist: "False",
      sub_tray_and_slot: [],
      machine_temp_field: [],
      email_receiver_list: [],
      tray_and_slot: [
        { value: "", id: 0 },
        { value: "", id: 1 },
        { value: "", id: 2 },
        { value: "", id: 3 },
        { value: "", id: 4 },
        { value: "", id: 5 },
      ],
      gkash_username: "",
      gkash_password: "",
      merchant_id: "",
      store_id: "",
      app_code: "",
      secret_key: "",
      headers: [
        {
          text: "Motor Number",
          value: "motor_number",
          divider: true,
          sortable: false,
          width: 100.0,
        },
        {
          text: "Slot Label",
          value: "slot_label",
          divider: true,
          sortable: false,
          width: 100.0,
        },
        {
          text: "Product Name",
          value: "product_name",
          divider: true,
          sortable: false,
        },
        {
          text: "Image",
          value: "product_image",
          divider: true,
          sortable: false,
          align: "center",
        },
        {
          text: "Selling Price (RM)",
          value: "selling_price",
          divider: true,
          sortable: false,
          width: 150.0,
        },
        {
          text: "Cost Price (RM)",
          value: "cost_price",
          divider: true,
          sortable: false,
          width: 120.0,
        },
      ],
      headers_v2: [
        {
          text: "Motor Number",
          value: "motor_number",
          divider: true,
          sortable: false,
          width: 100.0,
        },
        {
          text: "Slot Label",
          value: "slot_label",
          divider: true,
          sortable: false,
        },
        {
          text: "Product Name",
          value: "product_name",
          divider: true,
          sortable: false,
        },
        {
          text: "Product SKU",
          value: "product_sku",
          divider: true,
          sortable: false,
        },
        {
          text: "Image",
          value: "product_image",
          divider: true,
          sortable: false,
          align: "center",
        },
        {
          text: "Long Image",
          value: "product_description_image",
          divider: true,
          sortable: false,
          align: "center",
        },
        {
          text: "Selling Price (RM)",
          value: "selling_price",
          divider: true,
          sortable: false,
          width: 150.0,
        },
        {
          text: "2nd Price (RM)",
          value: "second_selling_price",
          divider: true,
          sortable: false,
          width: 120.0,
        },
        {
          text: "3rd Price (RM)",
          value: "third_selling_price",
          divider: true,
          sortable: false,
          width: 120.0,
        },
        {
          text: "4th Price (RM)",
          value: "fourth_selling_price",
          divider: true,
          sortable: false,
          width: 120.0,
        },
        {
          text: "5th Price (RM)",
          value: "fifth_selling_price",
          divider: true,
          sortable: false,
          width: 120.0,
        },
        {
          text: "6th Price (RM)",
          value: "sixth_selling_price",
          divider: true,
          sortable: false,
          width: 120.0,
        },
        {
          text: "Cost Price (RM)",
          value: "cost_price",
          divider: true,
          sortable: false,
          width: 120.0,
        },
      ],
      slot_list: [],
      table_loading: false,
      selected_motor_number: -1,
      is_validated: false,
      is_submitting: false,
      template_list: [],
      temp_template_list: [],
      selected_template_name: "",
      payment_options: [],
      temp_payment_options: [],
      selected_payment_options: [],
      company_details_list: [],
      company_name_options: [],
      selected_company_name: "",
      selected_company_doc_id: "",
      current_user_permission: [],
      current_user_company_doc_id: "",
      primary_color: "#F44336",
      redeem_color: "#F44336",
      add_to_cart_color: "#F44336",
      shopping_cart_color: "#F44336",
      credit_color: "#F44336",
      is_ipay88_vm_enable: false,
      ipay88_merchant_key: "",
      ipay88_merchant_code: "",
      is_sm_vm_enable: false,
      multiple_purchase: "True",
      sm_vm_token: "",
      machine_store_code: "",
      key_value: 0,
      whatsapp_api_token: "",
      whatsapp_phone_numbers: "",
      need_refund: "True",
      old_slot_info: [],
      refund_text: "",
      non_refund_text: "",
      machine_password: "",
      sleep_ads_video: "",
      top_banner_ads_video: "",
      top_banner_ads_error_message: "",
      sleep_ads_error_message: "",
      collection_item_image: "",
      showZeroPriceDialog: false,
      zeroPriceSlots: [],
      pendingAction: null
    };
  },
  methods: {
    check_payment_options() {
      // console.log("check_payment_options", this.selected_payment_options);
      var find_index = this.selected_payment_options.findIndex((x) =>
        x.includes("(IPay88)")
      );
      // console.log("find_index", find_index);
      this.is_ipay88_vm_enable = find_index < 0 ? false : true;
    },
    update_start_time_value(value) {
      const time = value.time;
      const index = value.index;
      if (index > -1) {
        this.email_receiver_list[index].email = time;
        // this.email_receiver_list[index].error_message = "";
      }
    },
    remove_date_time(value) {
      this.email_receiver_list.splice(value, 1);
    },
    add_date_time(value) {
      this.email_receiver_list.push({
        email: "",
        error_message: "",
      });
    },
    whatsapp_number_validation(whatsapp_numbers) {
      var is_valid = true;
      for (var i = 0; i < whatsapp_numbers.length; i++) {
        if (whatsapp_numbers.charCodeAt(i) < 48) {
          is_valid = false;
        } else if (whatsapp_numbers.charCodeAt(i) > 57) {
          if (
            whatsapp_numbers.charCodeAt(i) == 58 ||
            whatsapp_numbers.charCodeAt(i) > 59
          ) {
            is_valid = false;
          }
        }
      }
      return is_valid;
    },
    update_primary_colour(val) {
      this.primary_color = val;
    },
    update_redeem_color(val) {
      this.redeem_color = val;
    },
    update_add_to_cart_color(val) {
      this.add_to_cart_color = val;
    },
    update_shopping_cart_color(val) {
      this.shopping_cart_color = val;
    },
    update_credit_color(val) {
      this.credit_color = val;
    },
    check_company_name(val) {
      if (val == "Signature Market") {
        this.is_sm_vm_enable = true;
      } else {
        this.is_sm_vm_enable = false;
      }
    },
    validate_duplication() {
      return new Promise((resolve, reject) => {
        this.send_http_request("checkIsMachineIdTaken", {
          machine_id: this.machine_id,
        })
          .then((response) => {
            if (response.data.status == "OK") {
              resolve(true);
            } else {
              this.template_name_error_message = "Name is taken";
              resolve(false);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    checkZeroPrices() {
      const slotMap = new Map(); // Use map to group by slot label
      
      this.slot_list.forEach(slot => {
        const prices = [
          {price: slot.selling_price, label: 'Main'},
          {price: slot.second_selling_price, label: '2nd'},
          {price: slot.third_selling_price, label: '3rd'}, 
          {price: slot.fourth_selling_price, label: '4th'},
          {price: slot.fifth_selling_price, label: '5th'},
          {price: slot.sixth_selling_price, label: '6th'}
        ];
        
        const zeroPrices = prices
          .filter(({price}) => price === 0 || price === "0")
          .map(({label}) => label);
          
        if (zeroPrices.length > 0) {
          if (slotMap.has(slot.slot_label)) {
            slotMap.get(slot.slot_label).push(...zeroPrices);
          } else {
            slotMap.set(slot.slot_label, zeroPrices);
          }
        }
      });

      const zeroSlots = [];
      slotMap.forEach((prices, slotLabel) => {
        zeroSlots.push(`Slot ${slotLabel} - ${prices.join(', ')} price`);
      });

      return zeroSlots;
    },

    async edit_machine() {
      var is_validated = true;
      if (this.machine_id != this.original_machine_id) {
        is_validated = await this.validate_duplication();
      }
      if (is_validated) {
        const zeroSlots = this.checkZeroPrices();
        if (zeroSlots.length > 0) {
          this.zeroPriceSlots = zeroSlots;
          this.showZeroPriceDialog = true;
        }else{
          this.proceed_edit_machine();
          
        }
        
      } else {
        this.machine_id_error_message = "Machine ID is taken";
        this.is_submitting = false;
      }
    },
    async create_machine() {
      
      var result = await this.validate_duplication();
      if (result) {
        const zeroSlots = this.checkZeroPrices();
        if (zeroSlots.length > 0) {
          this.zeroPriceSlots = zeroSlots;
          this.showZeroPriceDialog = true;
        }else{
          this.proceed_create_machine();
        }
      } else {
        this.machine_id_error_message = "Machine ID is taken";
        this.is_submitting = false;
      }
    },

    check_is_any_image_uploading() {
      var is_any_image_uploading = false;
      this.slot_list.forEach((slot) => {
        if (slot.product_image == "Loading") {
          is_any_image_uploading = true;
        }
        if (slot.product_description_image == "Loading") {
          is_any_image_uploading = true;
        }
      });
      return is_any_image_uploading;
    },
    check_is_any_video_uploading() {
      var is_any_video_uploading = false;
      if (
        this.top_banner_ads_video == "Loading" ||
        this.top_banner_ads_video == ""
      ) {
        is_any_video_uploading = true;
      }
      if (this.sleep_ads_video == "Loading" || this.sleep_ads_video == "") {
        is_any_video_uploading = true;
      }
      return is_any_video_uploading;
    },
    async update_machine() {
      var machine_slot_validated = this.$refs.machine_slot_form.validate();
      var machine_info_validated = this.$refs.machine_info_form.validate();
      var ipay88_info_validated =
        this.current_user_company_doc_id == "" && this.is_ipay88_vm_enable
          ? this.$refs.ipay88_form.validate()
          : true;
      if (
        machine_slot_validated &&
        machine_info_validated &&
        ipay88_info_validated &&
        !this.check_is_any_image_uploading() &&
        !this.check_is_any_video_uploading()
      ) {
        this.is_submitting = true;
        if (
          this.selected_company_name != "" &&
          this.selected_company_name != "Nu Vending"
        ) {
          this.selected_company_doc_id = this.company_details_list.find(
            (o) => o.company_name === this.selected_company_name
          ).company_doc_id;
        } else {
          this.selected_company_doc_id = "";
        }
        if (
          this.merchant_id != "" ||
          this.store_id != "" ||
          this.app_code != "" ||
          this.secret_key != ""
        ) {
          if (this.current_user_company_doc_id == "") {
            if (this.$refs.ewallet_form.validate()) {
              var response = await this.send_http_request("updateEwallet", {
                machine_id: this.machine_id,
                merchant_id: this.merchant_id,
                store_id: this.store_id,
                application_code: this.app_code,
                secret_key: this.secret_key,
              });
              if (response.data.status == "OK") {
                if (this.action == "create") {
                  this.create_machine();
                } else {
                  this.edit_machine();
                }
              } else {
                this.show_snack_bar("error", "Something went wrong");
              }
            } else {
              this.show_snack_bar("error", "E-wallet info is missing");
              this.is_submitting = false;
            }
          } else {
            this.edit_machine();
          }
        } else {
          if (this.action == "create") {
            this.create_machine();
          } else {
            this.edit_machine();
          }
        }
      } else {
        if (this.check_is_any_image_uploading()) {
          this.show_snack_bar("error", "Ensure image upload finish");
        } else if (this.check_is_any_video_uploading()) {
          this.show_snack_bar("error", "Video must be uploaded");
        }
      }
    },
    async template_selected() {
      var index = this.temp_template_list.findIndex(
        (x) => x.machine_template_name == this.selected_template_name
      );
      if (index > -1) {
        this.show_close_loading("show", "Loading...");
        var response = await this.send_http_request(
          "getMachineTemplateDetails",
          { template_id: this.temp_template_list[index].template_id }
        );
        this.show_close_loading("close");
        if (response.data.status == "OK") {
          var result = response.data.result;
          this.machine_type = result.machine_type;
          this.tray_and_slot = [];
          this.sub_tray_and_slot = [];
          if (this.machine_type == "Nubox_v2") {
            result.tray_and_slot[0].forEach((slot_number, slot_index) => {
              this.tray_and_slot.push({
                value: slot_number.toString(),
                id: slot_index,
              });
            });
            if (result.tray_and_slot[1] != null) {
              result.tray_and_slot[1].forEach((slot_number, slot_index) => {
                this.sub_tray_and_slot.push({
                  value: slot_number.toString(),
                  id: slot_index,
                });
              });
            }

            this.is_sub_exist =
              this.sub_tray_and_slot.length > 0 ? "True" : "False";
            if (this.is_sub_exist == "False") {
              if (this.machine_temp_field.length > 1) {
                this.machine_temp_field.pop();
              }
            } else {
              if (this.machine_temp_field.length <= 1) {
                this.machine_temp_field.push("");
              }
            }
          } else {
            this.tray_and_slot = [];
            result.tray_and_slot.forEach((slot, slot_index) => {
              this.tray_and_slot.push({
                value: slot.toString(),
                id: slot_index,
              });
            });
          }

          this.slot_list = result.slot_list;
          this.slot_list.forEach((slot_item) => {
            if (this.machine_type == "Nubox_v2") {
              slot_item.product_sku =
                slot_item.product_sku == null || slot_item.product_sku == ""
                  ? "-"
                  : slot_item.product_sku;
              slot_item.product_description_image =
                slot_item.product_description_image != null
                  ? slot_item.product_description_image
                  : "";
              slot_item.selling_price = slot_item.new_price.split("|")[0];
              if (slot_item.new_price.split("|").length > 1) {
                slot_item.second_selling_price =
                  slot_item.new_price.split("|")[1];
                slot_item.third_selling_price =
                  slot_item.new_price.split("|")[2];
                slot_item.fourth_selling_price =
                  slot_item.new_price.split("|")[3];
                slot_item.fifth_selling_price =
                  slot_item.new_price.split("|")[4];
                slot_item.sixth_selling_price =
                  slot_item.new_price.split("|")[5];
              }
            }
            var index = this.old_slot_info.findIndex(
              (x) => x.motor_number == slot_item.motor_number
            );
            if (index > -1) {
              slot_item.inventory = this.old_slot_info[index].inventory;
              slot_item.max_capacity = this.old_slot_info[index].max_capacity;
            }
          });
        }
      }
    },
    async load_machine_template() {
      var response = await this.send_http_request(
        "getAllMachineTemplateWithCompanyID",
        {
          company_doc_id: this.current_user_company_doc_id,
          machine_type: this.machine_type,
        }
      );
      this.temp_template_list = response.data.result;
      this.temp_template_list.forEach((template) => {
        this.template_list.push(template.machine_template_name);
      });
    },
    async load_payment_options() {
      var response = await this.send_http_request("getAllPaymentMethods", {});
      this.temp_payment_options = response.data.result;
      this.temp_payment_options.forEach((option) => {
        this.payment_options.push(option.payment_name);
      });
    },
    async load_company_options() {
      var response = await this.send_http_request(
        "getAllCompaniesWithCompanyID",
        {
          company_doc_id: this.current_user_company_doc_id,
        }
      );
      this.company_details_list = response.data.result;
      this.company_name_options = ["Nu Vending"];
      this.company_details_list.forEach((option) => {
        this.company_name_options.push(option.company_name);
      });
    },
    clear_error_message(type) {
      if (type == "machine_id") {
        this.machine_id_error_message = "";
      } else if (type == "top_banner_ads") {
        this.top_banner_ads_error_message = "";
      } else if (type == "sleep_ads") {
        this.sleep_ads_error_message = "";
      }
    },
    image_selection_cancelled() {
      this.selected_motor_number = -1;
    },
    image_selected_error() {
      this.selected_motor_number = -1;
    },
    image_description_selected_error() {
      this.selected_motor_number = -1;
    },
    image_selected_success(url) {
      var index = this.slot_list.findIndex(
        (x) => x.motor_number == this.selected_motor_number
      );
      this.slot_list[index].product_image = url;
      this.selected_motor_number = -1;
    },
    image_description_selected_success(url) {
      var index = this.slot_list.findIndex(
        (x) => x.motor_number == this.selected_motor_number
      );
      this.slot_list[index].product_description_image = url;
      this.selected_motor_number = -1;
    },
    image_uploading() {
      var index = this.slot_list.findIndex(
        (x) => x.motor_number == this.selected_motor_number
      );
      this.slot_list[index].product_image = "Loading";
    },
    image_description_uploading() {
      var index = this.slot_list.findIndex(
        (x) => x.motor_number == this.selected_motor_number
      );
      this.slot_list[index].product_description_image = "Loading";
    },
    product_image_clicked(motor_number) {
      this.selected_motor_number = motor_number;
    },
    product_description_image_clicked(motor_number) {
      this.selected_motor_number = motor_number;
    },
    slot_changed() {
      this.key_value += 1;
      var original_slot_list = this.slot_list;
      this.slot_list = [];
      var motor_number = 0;
      this.load_machine_template();
      if (this.machine_type == "China") {
        if (this.machine_temp_field.length > 1) {
          this.is_sub_exist = "False";
          this.machine_temp_field.pop();
          this.sub_tray_and_slot = [];
        }
      } else {
        if (this.machine_temp_field.length < 1) {
          this.machine_temp_field.push("");
        }
      }
      if (this.tray_and_slot.length == 0) {
        this.tray_and_slot = [
          { value: "", id: 0 },
          { value: "", id: 1 },
          { value: "", id: 2 },
          { value: "", id: 3 },
          { value: "", id: 4 },
          { value: "", id: 5 },
        ];
      }
      var join_tray_slot = this.tray_and_slot.concat(this.sub_tray_and_slot);
      join_tray_slot.forEach((item, index) => {
        var slot_number = Number(item.value);
        // console.log(`slot: ${item.id}, val: ${item.value}, index: ${index}`);
        if (slot_number > 0 && slot_number <= 10) {
          for (var i = 0; i < slot_number; i++) {
            motor_number =
              index <= 5 ? item.id * 10 + i + 1 : item.id * 10 + i + 101;
            var ori_index = original_slot_list.findIndex(
              (x) => x.motor_number == motor_number
            );
            if (this.machine_type == "China") {
              this.slot_list.push({
                motor_number: motor_number,
                slot_label:
                  i == 0
                    ? Number(`${index}${i + 1}`)
                    : Number(
                        `${i > 8 ? index + 1 : index}${i > 8 ? 0 : i + 1}`
                      ),
                product_name:
                  ori_index > -1
                    ? original_slot_list[ori_index].product_name
                    : "",
                // product_image: 'https://storage.googleapis.com/mynuvendingtech.appspot.com/product_info/images/0a177910-f049-4bf6-a038-d477cd446140.jpeg',
                product_image:
                  ori_index > -1
                    ? original_slot_list[ori_index].product_image
                    : "",
                selling_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].selling_price
                    : 0.1,
                cost_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].cost_price
                    : 0.0,
                tray_number: i + 1, // Do it on purpose
                slot_number: index + 1, // Do it on purpose
              });
            } else if (this.machine_type == "Nubox_v2") {
              this.slot_list.push({
                motor_number: motor_number,
                slot_label: `${String.fromCharCode(index + 65)}${i + 1}`,
                product_name:
                  ori_index > -1
                    ? original_slot_list[ori_index].product_name
                    : "",
                product_sku:
                  ori_index > -1
                    ? original_slot_list[ori_index].product_sku
                    : "-",
                product_image:
                  ori_index > -1
                    ? original_slot_list[ori_index].product_image
                    : "",
                selling_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].selling_price
                    : 0.0,
                second_selling_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].second_selling_price == null
                      ? 0.0
                      : original_slot_list[ori_index].second_selling_price
                    : 0.0,
                third_selling_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].third_selling_price == null
                      ? 0.0
                      : original_slot_list[ori_index].third_selling_price
                    : 0.0,
                fourth_selling_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].fourth_selling_price == null
                      ? 0.0
                      : original_slot_list[ori_index].fourth_selling_price
                    : 0.0,
                fifth_selling_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].fifth_selling_price == null
                      ? 0.0
                      : original_slot_list[ori_index].fifth_selling_price
                    : 0.0,
                sixth_selling_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].sixth_selling_price == null
                      ? 0.0
                      : original_slot_list[ori_index].sixth_selling_price
                    : 0.0,
                cost_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].cost_price
                    : 0.0,
                is_updated: true,
                product_description_image:
                  ori_index > -1
                    ? original_slot_list[ori_index].product_description_image !=
                      null
                      ? original_slot_list[ori_index].product_description_image
                      : ""
                    : "",
                tray_number: i + 1, // Do it on purpose
                slot_number: index + 1, // Do it on purpose
              });
            } else {
              this.slot_list.push({
                motor_number: motor_number,
                slot_label: `${String.fromCharCode(index + 65)}${i + 1}`,
                product_name:
                  ori_index > -1
                    ? original_slot_list[ori_index].product_name
                    : "",
                // product_image: 'https://storage.googleapis.com/mynuvendingtech.appspot.com/product_info/images/0a177910-f049-4bf6-a038-d477cd446140.jpeg',
                product_image:
                  ori_index > -1
                    ? original_slot_list[ori_index].product_image
                    : "",
                selling_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].selling_price
                    : 0.1,
                cost_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].cost_price
                    : 0.0,
                tray_number: i + 1, // Do it on purpose
                slot_number: index + 1, // Do it on purpose
              });
            }
          }
          this.slot_list.forEach((slot_item) => {
            if (slot_item.product_sku == "" || slot_item.product_sku == null) {
              slot_item.product_sku = "-";
            }
          });
        }
      });
    },
    sub_slot_enable() {
      if (this.is_sub_exist == "False") {
        this.sub_tray_and_slot = [];
        // temp array size =1
        var first_machine_temp =
          this.machine_temp_field.length > 0
            ? this.machine_temp_field[0].toString()
            : "";
        this.machine_temp_field = [];
        this.machine_temp_field.push("");
        this.slot_changed();
      } else {
        this.sub_tray_and_slot = [
          { value: "", id: 0 },
          { value: "", id: 1 },
          { value: "", id: 2 },
          { value: "", id: 3 },
          { value: "", id: 4 },
          { value: "", id: 5 },
        ];
        // temp array size =2
        if (this.machine_temp_field.length != 2) {
          var first_machine_temp =
            this.machine_temp_field.length > 0
              ? this.machine_temp_field[0].toString()
              : "";
          var sec_machine_temp =
            this.machine_temp_field.length > 1
              ? this.machine_temp_field[1].toString()
              : "";
          this.machine_temp_field = [];
          this.machine_temp_field.push(first_machine_temp, sec_machine_temp);
          this.slot_changed();
        }
      }
    },
    capitalize_first_letter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    async load_info() {
      this.show_close_loading("show", "Loading...");
      var response = await this.send_http_request("getMachineDetails", {
        machine_doc_id: this.machine_doc_id,
      });
      this.show_close_loading("close");
      if (response.data.status == "OK") {
        var info = response.data.result;
        this.email_receiver_list = [];
        if (info.email_receiver == null || info.email_receiver.length == 0) {
          this.email_receiver_list = [{ email: "" }];
        } else {
          info.email_receiver.forEach((email) => {
            this.email_receiver_list.push({ email: email });
          });
        }
        this.api_key = info.api_key;
        let selected_company_id =
          info.company_doc_id != null ? info.company_doc_id : "";

        if (selected_company_id != "") {
          this.company_details_list.forEach((company) => {
            if (company.company_doc_id == selected_company_id) {
              this.selected_company_name = company.company_name;
              if (this.selected_company_name == "Signature Market") {
                this.is_sm_vm_enable = true;
              } else {
                this.is_sm_vm_enable = false;
              }
            }
          });
        }
        this.primary_color =
          info.primary_color == null ? "#F44336" : info.primary_color;
        this.redeem_color =
          info.redeem_color == null ? "#F44336" : info.redeem_color;
        this.add_to_cart_color =
          info.add_to_cart_color == null ? "#F44336" : info.add_to_cart_color;
        this.shopping_cart_color =
          info.shopping_cart_color == null
            ? "#F44336"
            : info.shopping_cart_color;
        this.credit_color =
          info.credit_color == null ? "#F44336" : info.credit_color;
        this.multiple_purchase =
          info.multiple_purchase == null
            ? "True"
            : info.multiple_purchase
            ? "True"
            : "False";
        this.machine_name = info.machine_name;
        this.sm_vm_token =
          info["SM VM Token"] == null ? "" : info["SM VM Token"];
        this.machine_store_code =
          info.machine_store_code == null ? "" : info.machine_store_code;
        this.machine_id = info.machine_id;
        this.original_machine_id = info.machine_id;
        this.location_name = info.location_name;
        this.machine_type = this.capitalize_first_letter(info.machine_type);
        this.gkash_username =
          info.gkash_username != null ? info.gkash_username : "";
        this.gkash_password =
          info.gkash_password != null ? info.gkash_password : "";
        this.merchant_id = info.merchant_id == null ? "" : info.merchant_id;
        this.store_id = info.store_id == null ? "" : info.store_id;
        this.app_code = info.app_code == null ? "" : info.app_code;
        this.secret_key = info.secret_key == null ? "" : info.secret_key;
        this.selected_payment_options = info.selected_payment_options;
        this.check_payment_options();
        this.ipay88_merchant_key = info.ipay88_merchant_key;
        this.ipay88_merchant_code = info.ipay88_merchant_code;
        this.refund_text =
          info.refund_text != null
            ? info.refund_text
            : "Failed items refund will be credited to your account.\nTnG: Within 7-14 days\nBoost / Grab: Immediate\nMaybank QR / Credit Card: Refund as credit";
        this.non_refund_text =
          info.non_refund_text != null
            ? info.non_refund_text
            : "Failed items refund will be credited to your account.\nFor more info please contact with technical support team.";

        this.whatsapp_api_token =
          info.whatsapp_api_token != null ? info.whatsapp_api_token : "";
        this.whatsapp_phone_numbers =
          info.whatsapp_phone_numbers != null
            ? info.whatsapp_phone_numbers
            : "";

        info.temperature_alert == null
          ? (this.machine_temp_field = [])
          : info.temperature_alert.forEach((item) => {
              this.machine_temp_field.push(item.toString());
            });

        this.tray_and_slot = [];
        this.sub_tray_and_slot = [];
        if (this.machine_type == "Nubox_v2") {
          const size = Number(Object.keys(info.tray_and_slot).length);
          var difference = size - this.machine_temp_field.length;
          for (var i = 0; i < difference; i++) {
            this.machine_temp_field.push("");
          }
          info.tray_and_slot[0].forEach((slot_number, slot_index) => {
            this.tray_and_slot.push({
              value: slot_number.toString(),
              id: slot_index,
            });
          });
          if (info.tray_and_slot[1] != null) {
            info.tray_and_slot[1].forEach((slot_number, slot_index) => {
              this.sub_tray_and_slot.push({
                value: slot_number.toString(),
                id: slot_index,
              });
            });
            this.is_sub_exist = "True";
          } else {
            this.is_sub_exist = "False";
          }
        } else {
          //jweijweijwei china machine no sub machine
          if (info.tray_and_slot.length == 6) {
            // this.tray_and_slot = [];
            info.tray_and_slot.forEach((item, index) => {
              this.tray_and_slot.push({ value: item.toString(), id: index });
            });
          }
        }

        this.slot_list = info.products;
        if (this.machine_type == "Nubox_v2") {
          this.slot_list.forEach((slot_item) => {
            slot_item.product_sku =
              slot_item.product_sku == null || slot_item.product_sku == ""
                ? "-"
                : slot_item.product_sku;
            slot_item.selling_price = slot_item.new_price.split("|")[0];
            if (slot_item.new_price.split("|").length > 1) {
              slot_item.second_selling_price =
                slot_item.new_price.split("|")[1];
              slot_item.third_selling_price = slot_item.new_price.split("|")[2];
              slot_item.fourth_selling_price =
                slot_item.new_price.split("|")[3];
              slot_item.fifth_selling_price = slot_item.new_price.split("|")[4];
              slot_item.sixth_selling_price = slot_item.new_price.split("|")[5];
            }

            slot_item.product_description_image =
              slot_item.product_description_image == null
                ? ""
                : slot_item.product_description_image;
          });
        }

        this.old_slot_info = [];

        this.slot_list.forEach((slot_item) => {
          this.old_slot_info.push({ ...slot_item });
        });

        this.need_refund =
          info.need_refund == null
            ? "True"
            : info.need_refund
            ? "True"
            : "False";

        this.machine_password =
          info.machine_password != null ? info.machine_password : "";

        this.top_banner_ads_video = info.top_banner_ads;
        this.sleep_ads_video = info.sleep_ads_video;
      } else {
        this.$router.push({ name: "MachineScreen" }).catch((err) => {});
      }
    },
    check_is_slot_changed(slot_info) {
      var index = this.old_slot_info.findIndex(
        (x) => x.motor_number == slot_info.motor_number
      );
      if (index > -1) {
        if (slot_info.slot_label != this.old_slot_info[index].slot_label) {
          return true;
        } else if (
          slot_info.product_name != this.old_slot_info[index].product_name
        ) {
          return true;
        } else if (
          slot_info.product_sku != this.old_slot_info[index].product_sku
        ) {
          return true;
        } else if (
          slot_info.product_image != this.old_slot_info[index].product_image
        ) {
          return true;
        } else if (
          slot_info.product_description_image !=
          this.old_slot_info[index].product_description_image
        ) {
          return true;
        } else if (
          slot_info.product_description_image !=
          this.old_slot_info[index].product_description_image
        ) {
          return true;
        } else if (slot_info.new_price != this.old_slot_info[index].new_price) {
          return true;
        } else if (this.old_slot_info[index].is_updated) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    upload_sleep_ads_video() {
      this.$refs.sleep_ads_video_upload.click();
    },
    sleep_ads_video_selected(e) {
      if (typeof e.target.files[0] != "undefined") {
        this.sleep_ads_video = "Loading";

        var file = e.target.files[0];

        var form_data = new FormData();
        form_data.append("video", file);

        this.upload_file("uploadVideo", form_data)
          .then((response) => {
            if (response.data.status == "OK") {
              this.clear_error_message("sleep_ads");
              this.sleep_ads_video = response.data.url;
            }
          })
          .catch((error) => {
            this.sleep_ads_video = error.toString();
            console.log(error);
          });
      }
    },
    upload_top_banner_ads_video() {
      this.$refs.top_banner_ads_video_upload.click();
    },
    top_banner_ads_video_selected(e) {
      if (typeof e.target.files[0] != "undefined") {
        this.top_banner_ads_video = "Loading";

        var file = e.target.files[0];

        var form_data = new FormData();
        form_data.append("video", file);

        this.upload_file("uploadVideo", form_data)
          .then((response) => {
            if (response.data.status == "OK") {
              this.clear_error_message("top_banner_ads");
              this.top_banner_ads_video = response.data.url;
            }
          })
          .catch((error) => {
            this.top_banner_ads_error_message = error.toString();
            console.log(error);
          });
      }
    },
    handleZeroPriceConfirm() {
      // Set flag to skip zero price check
      this.showZeroPriceDialog = false;
      // Force skip zero price check on next run
      if (this.$route.params.id == "create") {
        this.proceed_create_machine();
      } else {
        this.proceed_edit_machine();
      }
    },
    handleZeroPriceCancel() {
      this.showZeroPriceDialog = false;
      this.is_submitting = false;
    },

    async proceed_create_machine() {
      var actual_tray_and_slot = [];
      var email_list = this.email_receiver_list.map(function (item) {
        return item["email"];
      });

      if (this.machine_type == "China" || this.machine_type == "Nubox") {
        this.tray_and_slot.forEach((item) => {
          actual_tray_and_slot.push(Number(item.value));
        });
      } else {
        actual_tray_and_slot = { 0: [] };
        this.tray_and_slot.forEach((item) => {
          actual_tray_and_slot["0"].push(Number(item.value));
        });
        if (this.sub_tray_and_slot.length > 0) {
          actual_tray_and_slot["1"] = [];
          this.sub_tray_and_slot.forEach((item) => {
            actual_tray_and_slot["1"].push(Number(item.value));
          });
        }
      }

      this.slot_list.forEach((slot_info) => {
        slot_info.motor_number = Number(slot_info.motor_number);
        slot_info.new_price = `${slot_info.selling_price}`;
        if (this.machine_type == "Nubox_v2") {
          slot_info.new_price += `|${slot_info.second_selling_price}`;
          slot_info.new_price += `|${slot_info.third_selling_price}`;
          slot_info.new_price += `|${slot_info.fourth_selling_price}`;
          slot_info.new_price += `|${slot_info.fifth_selling_price}`;
          slot_info.new_price += `|${slot_info.sixth_selling_price}`;
        }
      });

      var temp_array = [];
        this.machine_temp_field.forEach((temperature) => {
          temp_array.push(Number(temperature));
      });
      var response = await this.send_http_request("createMachine", {
        user_id: this.$store.getters.getUserID,
          machine_id: this.machine_id,
          machine_name: this.machine_name,
          location_name: this.location_name,
          machine_type: this.machine_type,
          tray_and_slot: actual_tray_and_slot,
          slot_info: this.slot_list,
          gkash_username: this.gkash_username,
          gkash_password: this.gkash_password,
          merchant_id: this.merchant_id,
          store_id: this.store_id,
          email_receiver: email_list,
          app_code: this.app_code,
          secret_key: this.secret_key,
          selected_payment_options: this.selected_payment_options,
          company_doc_id: this.selected_company_doc_id,
          temperature_alert: temp_array,
          primary_color: this.primary_color,
          redeem_color: this.redeem_color,
          add_to_cart_color: this.add_to_cart_color,
          shopping_cart_color: this.shopping_cart_color,
          credit_color: this.credit_color,
          sm_vm_token: this.sm_vm_token,
          whatsapp_api_token: this.whatsapp_api_token,
          whatsapp_phone_numbers: this.whatsapp_phone_numbers,
          need_refund: this.need_refund == "True",
          machine_store_code: this.machine_store_code,
          refund_text: this.refund_text,
          non_refund_text: this.non_refund_text,
          machine_password:
            this.machine_password != null && this.machine_password != ""
              ? this.machine_password
              : "Vending8888",
          top_banner_ads: this.top_banner_ads_video,
          sleep_ads: this.sleep_ads_video,
          ipay88_merchant_key: this.ipay88_merchant_key,
          ipay88_merchant_code: this.ipay88_merchant_code,
          multiple_purchase: this.multiple_purchase == "True",
        });
        this.is_submitting = false;
        if (response.data.status == "OK") {
          this.show_snack_bar("success", "Machine Created");
          this.$router.push({ path: "/machines" });
        } else {
          this.show_snack_bar("error", "Something went wrong");
        }
    },

    async proceed_edit_machine() {
      var actual_tray_and_slot = [];
      var email_list = this.email_receiver_list.map(function (item) {
        return item["email"];
      });

      if (this.machine_type == "China" || this.machine_type == "Nubox") {
        this.tray_and_slot.forEach((item) => {
          actual_tray_and_slot.push(Number(item.value));
        });
      } else {
        actual_tray_and_slot = { 0: [] };
        this.tray_and_slot.forEach((item) => {
          actual_tray_and_slot["0"].push(Number(item.value));
        });
        if (this.sub_tray_and_slot.length > 0) {
          actual_tray_and_slot["1"] = [];
          this.sub_tray_and_slot.forEach((item) => {
            actual_tray_and_slot["1"].push(Number(item.value));
          });
        }
      }
      this.slot_list.forEach((slot_info) => {
        slot_info.motor_number = Number(slot_info.motor_number);
        slot_info.new_price = `${slot_info.selling_price}`;
        if (this.machine_type == "Nubox_v2") {
          slot_info.new_price += `|${slot_info.second_selling_price}`;
          slot_info.new_price += `|${slot_info.third_selling_price}`;
          slot_info.new_price += `|${slot_info.fourth_selling_price}`;
          slot_info.new_price += `|${slot_info.fifth_selling_price}`;
          slot_info.new_price += `|${slot_info.sixth_selling_price}`;
        }
        slot_info.is_updated = false;
        if (this.check_is_slot_changed(slot_info)) {
          slot_info.is_updated = true;
        }
      });
      var temp_array = [];
      this.machine_temp_field.forEach((temperature) => {
        temp_array.push(Number(temperature));
      });
      var response = await this.send_http_request("updateMachine", {
        user_id: this.$store.getters.getUserID,
        machine_doc_id: this.machine_doc_id,
        machine_id: this.machine_id,
        machine_name: this.machine_name,
        location_name: this.location_name,
        machine_type: this.machine_type,
        email_receiver: email_list,
        tray_and_slot: actual_tray_and_slot,
        slot_info: this.slot_list,
        gkash_username: this.gkash_username,
        gkash_password: this.gkash_password,
        merchant_id: this.merchant_id,
        store_id: this.store_id,
        app_code: this.app_code,
        secret_key: this.secret_key,
        selected_payment_options: this.selected_payment_options,
        company_doc_id: this.selected_company_doc_id,
        temperature_alert: temp_array,
        primary_color: this.primary_color,
        redeem_color: this.redeem_color,
        add_to_cart_color: this.add_to_cart_color,
        shopping_cart_color: this.shopping_cart_color,
        credit_color: this.credit_color,
        sm_vm_token: this.sm_vm_token,
        whatsapp_api_token: this.whatsapp_api_token,
        whatsapp_phone_numbers: this.whatsapp_phone_numbers,
        need_refund: this.need_refund == "True",
        machine_store_code: this.machine_store_code,
        refund_text: this.refund_text,
        non_refund_text: this.non_refund_text,
        machine_password:
          this.machine_password != null && this.machine_password != ""
            ? this.machine_password
            : "Vending8888",
        top_banner_ads: this.top_banner_ads_video,
        sleep_ads: this.sleep_ads_video,
        ipay88_merchant_key: this.ipay88_merchant_key,
        ipay88_merchant_code: this.ipay88_merchant_code,
        multiple_purchase: this.multiple_purchase == "True",
      });
      this.is_submitting = false;
      if (response.data.status == "OK") {
        this.show_snack_bar("success", "Machine Updated");
        this.$router.push({ path: "/machines" });
      } else {
        this.show_snack_bar("error", "Something went wrong");
      }

    },
  },
  async mounted() {
    this.load_payment_options();
    this.load_company_options();

    if (this.action != "create") {
      this.machine_doc_id = this.$route.params.id;
      await this.load_info();
    } else {
      this.machine_temp_field = [""];
    }

    this.load_machine_template();
  },
  created() {
    this.current_user_permission = this.$store.getters.getUserRoleList;
    this.current_user_company_doc_id = this.$store.getters.getUserCompanyDocId;

    if (this.current_user_company_doc_id != "") {
      if (this.$route.params.id == "create") {
        this.$router.push({ path: "/machines" });
      }
      if (
        !this.current_user_permission.includes("3BAFVFaySyJIFMdot8rB") &&
        !this.current_user_permission.includes("xg3QiWhT2SA6KdkGFAeP") &&
        !this.current_user_permission.includes("UsVr0wHOjW29JiLaIv0E")
      ) {
        this.$router.push({ name: "HomeScreen" }).catch((err) => {});
      }
    }

    // Update store
    var payload = { headerType: "needHeader", currentPage: "MachineScreen" };
    this.$store.dispatch("updateHeaderType", payload);
    this.$store.dispatch("updateCurrentPage", payload);
  },
  computed: {
    generalSpacingLeftRight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 5;
        case "sm":
          return 5;
        case "md":
          return 3;
        case "lg":
          return 3;
        case "xl":
          return 3;
        default:
          return 5;
      }
    },
  },
};
</script>

<style>
</style>